import React, { FC, memo, useMemo } from 'react'
import { spaceDigits } from '@ucheba/utils/helpers/number'

import { coreSelectors } from '@ucheba/store/core'

import Icon from '@ucheba/ui/icons/icon__closed-lock.svg'
import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop'
import { useSelector } from 'react-redux'
import { ILineParamProps } from '../types'
import { ProgressLine } from '../../ProgressLine/desktop'
import { Grid, GridCol } from '../../Grid/desktop'
import { Text } from '../../Text/desktop'
import { Spacing } from '../../Spacing/desktop'

import SC from '../base/LineParam.styles'

const { Block, StyledLockIcon } = SC

/** Параметр с линейным представлением */
const LineParam: FC<ILineParamProps> = (props) => {
  const {
    postfix,
    label,
    fontWeight,
    color,
    height,
    maxValue,
    minValue,
    currentMaxValue,
    currentMinValue,
    isLocked,
    onLockIconClick,
  } = props

  const isTouch = useSelector(coreSelectors.isTouch)

  const value = useMemo(() => {
    const num = currentMinValue
      ? `${currentMinValue}-${currentMaxValue}`
      : currentMaxValue

    if (currentMinValue && currentMaxValue) {
      return `${spaceDigits(currentMinValue)}-${spaceDigits(currentMaxValue)}`
    }

    return num ? spaceDigits(num) : 0
  }, [currentMaxValue, currentMinValue])

  return (
    <Block>
      <Grid spacing='xxsmall' justifyContent='space-between' nowrap>
        <GridCol width='auto' shrink='initial'>
          <Text fontWeight={fontWeight} nowrap>
            {label}
          </Text>
        </GridCol>

        <GridCol width='auto' shrink='initial'>
          {isLocked ? (
            <>
              {isTouch ? (
                <StyledLockIcon>
                  <Icon width='16px' height='16px' onClick={onLockIconClick} />
                </StyledLockIcon>
              ) : (
                <Tooltip
                  width='200px'
                  content={
                    <Text color='black'>Зарегистрируйтесь, чтобы увидеть данные</Text>
                  }
                  position='bottom-center'
                >
                  <StyledLockIcon>
                    <Icon width='16px' height='16px' onClick={onLockIconClick} />
                  </StyledLockIcon>
                </Tooltip>
              )}
            </>
          ) : (
            <Text fontWeight={fontWeight} nowrap>
              {postfix ? `${value} ${postfix}` : value}
            </Text>
          )}
        </GridCol>
      </Grid>

      <Spacing spacing='xxsmall' />

      <ProgressLine
        color={color}
        height={height}
        maxValue={isLocked ? 0 : maxValue}
        minValue={isLocked ? 0 : minValue}
        currentMaxValue={isLocked ? 0 : currentMaxValue}
        currentMinValue={isLocked ? 0 : currentMinValue}
      />
    </Block>
  )
}

export { LineParam }
export default memo(LineParam)
